import { Accept } from 'react-dropzone';

/**
 * Helper function that returns a string listing all of the accepted file types:
 * e.g.:
 * if provided an accept prop of:
 * {
 *  'image/*': ['.png']
 *  'text/html': ['.html', '.htm'],
 * },
 * the resulting string would be:
 * '.png, .html and .htm'. An "and" always appears before the last accepted file types.
 */
export const formulateAcceptedFileTypes = (accept?: Accept) => {
  if (!accept) {
    return 'all file types';
  }

  return Object.values(accept)
    .flatMap((values) => values)
    .reduce((acc, entry, i, array) => {
      switch (i) {
        case 0:
          return entry;
        case array.length - 1:
          return `${acc} and ${entry}`;
        default:
          return `${acc}, ${entry}`;
      }
    }, '');
};
